import Vue from 'vue'
import App from './App.vue'
import router from './router'

Vue.config.productionTip = false

import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)

VueClipboard.config.autoSetContainer = true

import './app.scss'

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
